__turbopack_context__.v({
  "fade-in": "OverflowGrid-module-scss-module__Udocia__fade-in",
  "grid": "OverflowGrid-module-scss-module__Udocia__grid",
  "gridWrapper": "OverflowGrid-module-scss-module__Udocia__gridWrapper",
  "header": "OverflowGrid-module-scss-module__Udocia__header",
  "headingIcon": "OverflowGrid-module-scss-module__Udocia__headingIcon",
  "headingLink": "OverflowGrid-module-scss-module__Udocia__headingLink",
  "headingText": "OverflowGrid-module-scss-module__Udocia__headingText",
  "item": "OverflowGrid-module-scss-module__Udocia__item",
  "navButtons": "OverflowGrid-module-scss-module__Udocia__navButtons",
  "no-transform": "OverflowGrid-module-scss-module__Udocia__no-transform",
  "rotate": "OverflowGrid-module-scss-module__Udocia__rotate",
  "section": "OverflowGrid-module-scss-module__Udocia__section",
});
